import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import faExclamationTriangle from '@fortawesome/fontawesome-free-solid/faExclamationTriangle';

class RegisterEmail extends Component {
  state = {
    email: '',
    emailVerified: false,
  };

  onEmailChange = (event) => {
    this.props.handleChange(event.target.value, 'email');
  };

  render() {
    const { email, valid } = this.props;

    return (
      <div className="field is-horizontal">
        <div className="field-label is-medium">
          <label className="label">購買人電子信箱</label>
        </div>
        <div className="field-body">
          <div className="field">
            <p className="control is-expanded has-icons-left has-icons-right">
              <input
                className={
                  !valid && email.length > 0
                    ? 'input is-danger'
                    : 'input'
                }
                type="email"
                id="email"
                value={email}
                placeholder="電子郵件"
                onChange={this.onEmailChange}
              />
              <span className="icon is-small is-left">
                <FontAwesomeIcon className="icon" icon={faEnvelope} />
              </span>
              <span className="icon is-small is-right">
                <FontAwesomeIcon
                  className="icon"
                  icon={valid ? faCheck : faExclamationTriangle}
                />
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

RegisterEmail.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default RegisterEmail;



// WEBPACK FOOTER //
// ./src/components/RegisterEmail.js